__turbopack_context__.v({
  "quickTasksTable": "_8nbuIW_quickTasksTable",
  "quickTasksTable__assignee": "_8nbuIW_quickTasksTable__assignee",
  "quickTasksTable__assigneeCell": "_8nbuIW_quickTasksTable__assigneeCell",
  "quickTasksTable__cellAction": "_8nbuIW_quickTasksTable__cellAction",
  "quickTasksTable__contextInternal": "_8nbuIW_quickTasksTable__contextInternal",
  "quickTasksTable__description": "_8nbuIW_quickTasksTable__description",
  "quickTasksTable__dueDateCell": "_8nbuIW_quickTasksTable__dueDateCell",
  "quickTasksTable__meterStack": "_8nbuIW_quickTasksTable__meterStack",
  "quickTasksTable__serviceType": "_8nbuIW_quickTasksTable__serviceType",
  "quickTasksTable__serviceTypeCell": "_8nbuIW_quickTasksTable__serviceTypeCell",
  "quickTasksTable__standaloneCreate": "_8nbuIW_quickTasksTable__standaloneCreate",
  "quickTasksTable__standaloneCreateRow": "_8nbuIW_quickTasksTable__standaloneCreateRow",
  "quickTasksTable__taskName": "_8nbuIW_quickTasksTable__taskName",
  "quickTasksTable__taskTitle": "_8nbuIW_quickTasksTable__taskTitle",
  "quickTasksTable__timelineAlert": "_8nbuIW_quickTasksTable__timelineAlert",
});
